import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialDemandInfosService } from './logic/materialdemandinfos.service';
import { MaterialDemandInfosLogicService } from './logic/materialdemandinfo/materialdemandinfos-logic.service';
import { MaterialDemandsDaoService } from './dao/material-demand-dao.service';
import { MaterialDemandsDbDaoService } from './dao/material-demand-dao/material-demand-db-dao.service';
import { MaterialDemandPositionsDaoService } from './dao/material-demand-position-dao.service';
import { MaterialDemandPositionsDbDaoService } from './dao/material-demand-position-dao/material-demand-position-db-dao.service';
import { MaterialDeliveriesDaoService } from './dao/material-delivery-dao.service';
import { MaterialDeliveriesDbDaoService } from './dao/material-delivery-dao/material-delivery-db-dao.service';
import { MaterialDemandDbTableDefinition } from './dao/material-demand-dao/material-demand-db-table-definition';
import { MaterialDemandPositionDbTableDefinition } from './dao/material-demand-position-dao/material-demand-position-db-table-definition';
import { MaterialDeliveriesDbTableDefinition } from './dao/material-delivery-dao/material-delivery-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: MaterialDemandInfosService,
      useClass: MaterialDemandInfosLogicService,
    },
    {
      provide: MaterialDemandsDaoService,
      useClass: MaterialDemandsDbDaoService,
    },
    {
      provide: MaterialDemandPositionsDaoService,
      useClass: MaterialDemandPositionsDbDaoService,
    },
    {
      provide: MaterialDeliveriesDaoService,
      useClass: MaterialDeliveriesDbDaoService,
    },
    { provide: MaterialDemandDbTableDefinition },
    { provide: MaterialDemandPositionDbTableDefinition },
    { provide: MaterialDeliveriesDbTableDefinition },
  ],
})
export class MaterialDemandInfosServiceModule {}
